import Splide from '@splidejs/splide';

export default class Slider {
  constructor() {
    const sliderContainers = document.querySelectorAll('.slider');

    if (sliderContainers) {
      sliderContainers.forEach((sliderContainer) => {
        const slider = sliderContainer.querySelector('.splide');
        if (sliderContainer.classList.contains('slider-block')) {
          new Splide(slider, {
            type: 'slide',
            autoplay: 0,
            gap: 15,
            perPage: 3,
            arrows: false,
            pagination: true,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          }).mount();
        }
      });
    }
  }
}
